import { Home, TrendingUp, Search, User, PlusCircle, MessageCircle } from 'lucide-react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { useAuthStore } from '@/stores/auth-store'
import { toast } from 'sonner'
import { cn } from '@/lib/utils'

export function BottomNavigation() {
  const navigate = useNavigate()
  const location = useLocation()
  const { isAuthenticated } = useAuthStore()

  const handlePublishClick = () => {
    if (isAuthenticated) {
      navigate('/publish')
    } else {
      toast.info('请先登录后发布动态')
      navigate('/login')
    }
  }

  const handleProfileClick = () => {
    if (isAuthenticated) {
      navigate('/profile')
    } else {
      navigate('/login')
    }
  }

  const handleMessageClick = () => {
    if (isAuthenticated) {
      navigate('/messages')
    } else {
      toast.info('请先登录后查看消息')
      navigate('/login')
    }
  }

  const navItems = [
    {
      icon: Home,
      label: '首页',
      path: '/',
      onClick: () => navigate('/')
    },
    {
      icon: TrendingUp,
      label: '热门',
      path: '/trending',
      onClick: () => navigate('/trending')
    },
    {
      icon: PlusCircle,
      label: '发布',
      path: '/publish',
      onClick: handlePublishClick,
      special: true
    },
    {
      icon: MessageCircle,
      label: '消息',
      path: '/messages',
      onClick: handleMessageClick,
      badge: isAuthenticated ? undefined : '!'
    },
    {
      icon: User,
      label: '我的',
      path: '/profile',
      onClick: handleProfileClick,
      badge: isAuthenticated ? undefined : '!'
    }
  ]

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-lg border-t border-gray-200/50 shadow-lg md:hidden">
      <div className="flex items-center justify-around px-2 py-2 safe-area-pb">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = location.pathname === item.path || 
            (item.path === '/' && location.pathname === '/') ||
            (item.path !== '/' && location.pathname.startsWith(item.path))

          return (
            <Button
              key={item.path}
              variant="ghost"
              size="sm"
              onClick={item.onClick}
              className={cn(
                "flex flex-col items-center justify-center h-14 w-14 rounded-xl relative transition-all duration-200",
                item.special 
                  ? "bg-gradient-to-r from-primary to-primary/90 text-white hover:from-primary/90 hover:to-primary shadow-lg hover:shadow-xl transform hover:scale-105" 
                  : isActive 
                    ? "bg-primary/10 text-primary" 
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
              )}
            >
              <Icon className={cn(
                "transition-all duration-200",
                item.special ? "w-6 h-6" : "w-5 h-5"
              )} />
              <span className={cn(
                "text-xs font-medium mt-1 transition-all duration-200",
                item.special ? "text-white" : ""
              )}>
                {item.label}
              </span>
              
              {item.badge && (
                <Badge className="absolute -top-1 -right-1 w-4 h-4 p-0 flex items-center justify-center text-xs bg-destructive">
                  {item.badge}
                </Badge>
              )}
            </Button>
          )
        })}
      </div>
    </nav>
  )
}